import React from 'react';

/** Enveloppe racine Puck — fond de page + contenu. */
export default function PageRoot({ children, backgroundColor = '#ffffff' }) {
  return (
    <div
      style={{
        minHeight: '100%',
        backgroundColor: backgroundColor || '#ffffff',
      }}
    >
      {children}
    </div>
  );
}
